/* Pelle & Sol redesign: pack picker + dispatch/delivery estimate. */
(() => {
  // --- Pack value picker: a card click selects the matching native variant input ---
  document.addEventListener('click', (evt) => {
    const card = evt.target.closest('.ps-pack[data-variant-id]');
    if (!card) return;
    const scope = card.closest('.product-info') || card.closest('.shopify-section') || document;
    const input = scope.querySelector(`variant-picker input[data-variant-id="${card.dataset.variantId}"]`);
    card.parentElement.querySelectorAll('.ps-pack').forEach((el) => {
      el.classList.toggle('is-selected', el === card);
      el.setAttribute('aria-checked', el === card ? 'true' : 'false');
    });
    if (input && !input.checked) input.click();
  });

  // --- Multi-buy tiers: a card sets the quantity; the quantity input keeps the right card highlighted ---
  const mbQtyInput = (mb) => {
    const scope = mb.closest('.product-info') || document;
    return scope.querySelector('.js-product-form-main input[name="quantity"]');
  };
  const mbSync = (mb) => {
    const input = mbQtyInput(mb);
    const q = Math.max(1, parseInt(input && input.value, 10) || 1);
    const cards = [...mb.querySelectorAll('.ps-mb__tier')];
    let active = cards[0];
    cards.forEach((c) => { if (+c.dataset.qty <= q) active = c; });
    cards.forEach((c) => {
      c.classList.toggle('is-selected', c === active);
      c.setAttribute('aria-checked', c === active ? 'true' : 'false');
    });
    // under the cards: "Add 1 more pack to save 5%"; from the top tier, "Buying more than 8? ..." (data-top)
    const nudge = mb.querySelector('[data-ps-mb-nudge]');
    if (nudge) {
      const next = cards.find((c) => +c.dataset.qty > q);
      const word = (n) => (n === 1 ? mb.dataset.unit : mb.dataset.units);
      nudge.textContent = next
        ? `Add ${+next.dataset.qty - q} more ${word(+next.dataset.qty - q)} to save ${next.dataset.pct}%`
        : nudge.dataset.top;
    }
    // price under the title: discounted price per unit for the quantity, full price crossed out
    const priceEl = (mb.closest('.product-info') || document).querySelector('.product-info__price .price');
    const unitPrice = +mb.dataset.price;
    if (priceEl && unitPrice) {
      const money = (p) => (mb.dataset.moneyFormat || '£{{amount}}')
        .replace(/\{\{\s*amount\s*\}\}/, (p / 100).toFixed(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(p / 100));
      const pct = +active.dataset.pct || 0;
      const each = unitPrice - Math.floor((unitPrice * pct) / 100); // Shopify floors the saving per unit
      const cur = priceEl.querySelector('.price__current .js-value');
      const was = priceEl.querySelector('.price__was .js-value');
      if (cur) cur.textContent = money(each);
      if (was) was.textContent = money(unitPrice);
      priceEl.classList.toggle('price--on-sale', pct > 0);
      let tag = priceEl.querySelector('.ps-price-each');
      if (!tag && cur) {
        tag = document.createElement('span');
        tag.className = 'ps-price-each';
        cur.after(tag);
      }
      if (tag) tag.textContent = pct > 0 ? ' each' : '';
    }
  };
  const mbEnsureVariant = (mb) => {
    // sold as one variant: if a hidden pack size was preselected (e.g. ?variant= in the URL), switch back
    const scope = mb.closest('.product-info') || document;
    const idInput = scope.querySelector('.js-product-form-main input[name="id"]');
    if (idInput && idInput.value !== mb.dataset.variantId) {
      const opt = scope.querySelector(`variant-picker input[data-variant-id="${mb.dataset.variantId}"]`);
      if (opt && !opt.checked) opt.click();
    }
  };
  document.addEventListener('click', (evt) => {
    const card = evt.target.closest('.ps-mb__tier');
    if (!card) return;
    const mb = card.closest('[data-ps-multibuy]');
    const input = mbQtyInput(mb);
    mbEnsureVariant(mb);
    if (input) {
      input.value = card.dataset.qty;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    mbSync(mb);
  });
  const mbAll = () => document.querySelectorAll('[data-ps-multibuy]').forEach(mbSync);
  document.addEventListener('change', (evt) => { if (evt.target.name === 'quantity') mbAll(); });
  document.addEventListener('input', (evt) => { if (evt.target.name === 'quantity') mbAll(); });
  document.addEventListener('click', (evt) => { if (evt.target.closest('.qty-input__btn')) setTimeout(mbAll, 0); });
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ps-multibuy]').forEach((mb) => { mbEnsureVariant(mb); mbSync(mb); });
  });

  // --- Fire kit visibility: Shopify drops the kit once the cart reaches the second multi-buy tier, so hide the card
  // when adding it would get there (see snippets/ps-pdp-kit.liquid) ---
  let kitTimer;
  const kitVisibility = () => {
    const kits = document.querySelectorAll('[data-ps-kit][data-second-min]');
    if (!kits.length) return;
    clearTimeout(kitTimer);
    kitTimer = setTimeout(async () => {
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const cart = await (await fetch(`${root}cart.js`)).json();
        kits.forEach((kit) => {
          const min = +kit.dataset.secondMin;
          const q = cart.items.filter((i) => String(i.variant_id) === kit.dataset.trigger).reduce((n, i) => n + i.quantity, 0);
          // after adding the kit there are n of the main item; Shopify keeps a kit only if it saves more than
          // the multi-buy tier would on all n
          const n = q + 1;
          const price = +kit.dataset.mainPrice || 0;
          let pct = 0;
          (kit.dataset.tiers || '').split(',').forEach((t) => {
            const [tq, tp] = t.split(':').map(Number);
            if (tq && n >= tq) pct = tp;
          });
          const tierTotal = Math.floor((price * pct) / 100) * n;
          const pick = kit.querySelector('[data-ps-kit-select]');
          let any = false;
          if (pick && pick.tagName === 'SELECT') {
            [...pick.options].forEach((o) => {
              const ok = +o.dataset.save > tierTotal;
              o.hidden = !ok;
              o.disabled = !ok;
              any = any || ok;
            });
            if (pick.selectedOptions[0] && pick.selectedOptions[0].disabled) {
              const first = [...pick.options].find((o) => !o.disabled);
              if (first) {
                pick.value = first.value;
                pick.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          } else if (pick) {
            any = +pick.dataset.save > tierTotal;
          }
          kit.hidden = (min > 0 && n >= min) || !any;
        });
      } catch (e) { /* keep the card as rendered */ }
    }, 400);
  };
  document.addEventListener('DOMContentLoaded', kitVisibility);
  document.addEventListener('on:cart:add', kitVisibility);
  document.addEventListener('on:line-item:change', kitVisibility);

  // --- Fire kit: add the main product and the chosen add-on in one request, then open the cart drawer ---
  document.addEventListener('change', (evt) => {
    const sel = evt.target.closest('[data-ps-kit-select]');
    if (!sel) return;
    const kit = sel.closest('[data-ps-kit]');
    const opt = sel.selectedOptions[0];
    // <option>s carry data-now too, so target the price elements explicitly
    kit.querySelector('strong[data-now]').textContent = opt.dataset.now;
    kit.querySelector('s[data-was]').textContent = opt.dataset.was;
  });
  document.addEventListener('click', async (evt) => {
    const btn = evt.target.closest('[data-ps-kit-add]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    const kit = btn.closest('[data-ps-kit]');
    const addon = kit.querySelector('[data-ps-kit-select]').value;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const drawer = document.querySelector('cart-drawer');
    const sections = ['cart-icon-bubble'];
    if (drawer && drawer.closest('.shopify-section')) {
      sections.push(drawer.closest('.shopify-section').id.replace('shopify-section-', ''));
    }
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: +kit.dataset.trigger, quantity: 1 }, { id: +addon, quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || res.status);
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: +addon } }));
      if (drawer && data.sections) {
        drawer.renderContents(data, true); // also updates the cart icon count
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (e) {
      const msg = kit.querySelector('[data-ps-kit-msg]');
      if (msg) msg.textContent = String(e.message || e);
    } finally {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
    }
  });

  // --- Sticky add-to-cart bar: submit the real product form so the theme's cart drawer flow runs ---
  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('[data-ps-sticky-add]');
    if (!btn) return;
    const section = btn.closest('.cc-main-product') || document;
    const add = section.querySelector('.js-product-form-main button[name="add"]');
    if (add && !add.disabled) add.click();
  });

  // --- Cart page: the theme only re-renders items + summary, so refresh the offers/delivery block too ---
  let extrasTimer;
  const refreshCartPageExtras = () => {
    const box = document.querySelector('.ps-cart-page-extras[data-ps-section]');
    if (!box) return;
    clearTimeout(extrasTimer);
    extrasTimer = setTimeout(async () => {
      const id = box.dataset.psSection;
      const res = await fetch(`${window.location.pathname}?sections=${id}`);
      if (!res.ok) return;
      const html = (await res.json())[id] || '';
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.ps-cart-page-extras');
      box.innerHTML = fresh ? fresh.innerHTML : '';
    }, 900); // after the theme's own 700ms cart refresh
  };
  document.addEventListener('on:cart:add', refreshCartPageExtras);
  document.addEventListener('on:line-item:change', refreshCartPageExtras);

  // --- Cart offers: variant select updates the shown (discounted) price ---
  document.addEventListener('change', (evt) => {
    const select = evt.target.closest('[data-ps-offer-select]');
    if (!select) return;
    const opt = select.selectedOptions[0];
    const card = select.closest('[data-ps-offer]');
    if (!opt || !card) return;
    card.querySelector('strong[data-now]').textContent = opt.dataset.now;
    card.querySelector('s[data-was]').textContent = opt.dataset.was;
  });

  // --- Dispatch countdown + delivery window, in UK time ---
  // England & Wales bank holidays (no dispatch or delivery on these days).
  const HOLIDAYS = new Set([
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'
  ]);
  const fmtParts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const dayFmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  const longDay = new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' });

  const ukNow = () => {
    const p = Object.fromEntries(fmtParts.formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour, m: +p.minute };
  };
  const iso = (d) => d.toISOString().slice(0, 10);
  const isWorkDay = (d) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !HOLIDAYS.has(iso(d));
  const addDays = (d, n) => new Date(d.getTime() + n * 86400000);
  const nextWorkDay = (d) => { let x = addDays(d, 1); while (!isWorkDay(x)) x = addDays(x, 1); return x; };
  const addWorkDays = (d, n) => { let x = d; for (let i = 0; i < n; i++) x = nextWorkDay(x); return x; };

  function update(el) {
    const cutoff = +el.dataset.cutoff || 16;
    const min = +el.dataset.min || 1;
    const max = +el.dataset.max || 2;
    const now = ukNow();
    const mins = now.h * 60 + now.m;
    // Zero-stock (backorder) lines ship the next working day, so never promise same-day for them.
    const backorder = el.hasAttribute('data-backorder');
    const sameDay = !backorder && isWorkDay(now.date) && mins < cutoff * 60;
    const dispatch = sameDay ? now.date : nextWorkDay(now.date);
    const from = addWorkDays(dispatch, min);
    const to = addWorkDays(dispatch, max);

    const eta = el.querySelector('[data-eta]');
    const cut = el.querySelector('[data-cut]');
    if (eta) eta.textContent = `· arrives ${dayFmt.format(from)} – ${dayFmt.format(to)}`;
    if (cut) {
      if (sameDay) {
        const left = cutoff * 60 - mins;
        const hh = Math.floor(left / 60);
        const mm = left % 60;
        cut.innerHTML = `Order within <strong>${hh ? `${hh}h ` : ''}${mm}m</strong> for same-day dispatch`;
      } else {
        const tomorrow = iso(dispatch) === iso(addDays(now.date, 1));
        cut.innerHTML = `Order now for dispatch <strong>${tomorrow ? 'tomorrow' : longDay.format(dispatch)}</strong>`;
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-ps-delivery]:not([data-ps-done])').forEach((el) => {
      el.setAttribute('data-ps-done', '');
      update(el);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  init();
  // The theme swaps the block's HTML on variant change; pick up the new node once.
  new MutationObserver(() => init()).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(() => document.querySelectorAll('[data-ps-delivery]').forEach(update), 60000);
})();
